import { all, fork, takeEvery } from 'redux-saga/effects'
import { stardardRequest } from '../../utils'
import { API_BASE } from '../../constants/api.constant'
import {
  VEHICLE_EXCLUSIONS_FETCH,
  VEHICLE_EXCLUSIONS_LOOKUP,
  VEHICLE_EXCLUSIONS_UPSERT,
  VEHICLE_EXCLUSIONS_DELETE
} from '../actions'

export function* watchVehicleExclusionsFetch() {
  const action = VEHICLE_EXCLUSIONS_FETCH
  yield takeEvery(action.REQUEST, stardardRequest({
    action,
    authProvider: 'firebase',
    requestOptionsFromPayload: () => ({
      method: 'get',
      url: `${API_BASE}/vehicle-exclusion/fetch`
    }),
    dataPath: null,
  }))
}

export function* watchVehicleExclusionsLookup() {
  const action = VEHICLE_EXCLUSIONS_LOOKUP
  yield takeEvery(action.REQUEST, stardardRequest({
    action,
    authProvider: 'firebase',
    requestOptionsFromPayload: (payload) => ({
      method: 'get',
      url: `${API_BASE}/vehicle-exclusion/lookup`,
      params: {
        field: payload.field,
        ...(payload.make ? { make: payload.make } : {})
      }
    }),
    dataPath: null,
  }))
}

export function* watchVehicleExclusionsUpsert() {
  const action = VEHICLE_EXCLUSIONS_UPSERT
  yield takeEvery(action.REQUEST, stardardRequest({
    action,
    authProvider: 'firebase',
    requestOptionsFromPayload: (payload) => ({
      method: 'post',
      url: `${API_BASE}/vehicle-exclusion/upsert`,
      data: {
        ...payload
      }
    }),
    dataPath: null,
  }))
}

export function* watchVehicleExclusionsDelete() {
  const action = VEHICLE_EXCLUSIONS_DELETE
  yield takeEvery(action.REQUEST, stardardRequest({
    action,
    authProvider: 'firebase',
    requestOptionsFromPayload: (payload) => ({
      method: 'post',
      url: `${API_BASE}/vehicle-exclusion/delete/${payload.id}`
    }),
    dataPath: null,
  }))
}

export default function* rootSaga() {
  yield all([
    fork(watchVehicleExclusionsFetch),
    fork(watchVehicleExclusionsLookup),
    fork(watchVehicleExclusionsUpsert),
    fork(watchVehicleExclusionsDelete),
  ])
}
